<template>
	<header class="menu-header">
		<div class="menu-header__wrapper">
			<div class="main-logo">
				<a>
					<component
						:is="iconComponent(`logo-${themeName}`)"
					/>
				</a>
			</div>
			<div class="menu-header__content">
				<h1
					class="menu-header__title"
					v-html="title"
				/>
				<h2
					class="menu-header__subtitle"
					v-html="subtitle"
				/>
			</div>
		</div>
	</header>
</template>

<script>

export default {
	props: {
		title: String,
		subtitle: String,
	},
}
</script>

<style>

</style>
